import { gql, TypedDocumentNode } from "@apollo/client";

import { Policy, PolicyUpdateInput } from "types/generated";

export const GET_POLICY = gql`
  query GetPolicyForDetails($policyId: ID!) {
    policy(id: $policyId) {
      id
      name
      body
      description
      spaceDetails {
        id
        name
        accessLevel
      }
      labels
      createdAt
      updatedAt
      type
      hasAttachedStacks
      sampleCount
      engineType
      plugin {
        id
        name
      }
      attachedStacks {
        isModule
        stackName
        id
        stackId
        stackSpaceDetails {
          name
          id
        }
      }
      attachedIntentProjects {
        id
        policyID
        policyName
        projectID
        projectName
        projectSpaceDetails {
          id
          name
        }
      }
    }
  }
`;

export type UpdatePolicyData = Pick<Policy, "id" | "name" | "body" | "space" | "engineType">;

type UpdatePolicyV2Variables = Partial<{
  id: string;
  input: PolicyUpdateInput;
}>;

/* eslint-disable @cspell/spellchecker */
export const UPDATE_POLICY_V2: TypedDocumentNode<
  { policyUpdatev2: UpdatePolicyData },
  UpdatePolicyV2Variables
> = gql`
  mutation UpdatePolicyDetailsV2($id: ID!, $input: PolicyUpdateInput!) {
    policyUpdatev2(id: $id, input: $input) {
      id
      name
      body
      space
      engineType
    }
  }
`;
/* eslint-enable @cspell/spellchecker */
